import axios from 'axios';
import {systemEnvironmentApiUrl} from '../../../helpers/url';

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getProducts() {
    return axios
        .get(`${systemEnvironmentApiUrl()}/api/v1/products`)
        .then((response) => response.data);
}



// WEBPACK FOOTER //
// ./src/components/locator/api/parameters.js